module.exports = __webpack_public_path__ + "img/材料力学8_6.7dd08dbd.jpg";